<div class="quiz-container">
  <div class="progress-bar">
    <div class="progress-thumb" [style.width.%]="progress"></div>
  </div>
  @if (data) {
    <div class="quiz-step">
      @if (data.topIcon) {
        <div class="icon" [@fadeAnimation]>{{ data.topIcon }}</div>
      }
      <div class="title" [innerHTML]="data.title" [@fadeAnimation]></div>
      @if (
        data.subtitle &&
        !(data.rive || data.textDemo || data.videoFilePath || (data.imageConfig && !data.isVoting))
      ) {
        <div class="subtitle" [innerHTML]="data.subtitle" [@fadeAnimation]></div>
      }
      @if (
        data.options ||
        data.messages ||
        data.mediaCite ||
        data.rive ||
        data.videoFilePath ||
        data.imageConfig ||
        data.audioTracks ||
        data.hasSocialProof ||
        data.userReview ||
        data.textDemo ||
        data.comparison ||
        data.planCards
      ) {
        <div class="content-container d-flex flex-column align-items-center mt-20">
          @if (data.isQuizBadgeShown) {
            <div class="d-flex gap-8 w-100 justify-content-center">
              <div
                class="hint-pane d-flex align-items-center justify-content-center orange"
                [@fadeAnimation]
              >
                <i class="ri-voice-ai-fill"></i>
                <span i18n="@@aiPowered">AI-powered</span>
              </div>
              <div
                class="hint-pane d-flex align-items-center justify-content-center blue"
                [@fadeAnimation]
              >
                <i class="ri-time-line"></i>
                <span i18n="@@oneMinQuiz">1-min quiz</span>
              </div>
            </div>
          }
          <form [formGroup]="form" class="w-100">
            @if (data.options && !data.isChips) {
              <!-- Multiple selection list -->
              <mat-selection-list
                [ngClass]="{
                  'grid-list-odd': data.options.length % 2,
                  'grid-list': data.isTilesDisplay,
                }"
                [multiple]="data.isMultiple"
                formControlName="selectedOptions"
                (selectionChange)="optionClicked()"
              >
                @for (option of data.options; track option) {
                  <mat-list-option
                    [value]="option.id"
                    [ngClass]="{ image: option.imageFilePath || option.rive }"
                  >
                    <app-quiz-list-option [option]="option"></app-quiz-list-option>
                  </mat-list-option>
                }
              </mat-selection-list>
            }
            @if (data.options && data.isChips) {
              <mat-chip-listbox
                formControlName="selectedOptions"
                [multiple]="true"
                aria-label="Options selection"
              >
                @for (option of data.options; track option) {
                  <mat-chip-option [value]="option.id">
                    {{ option.title }}
                  </mat-chip-option>
                }
              </mat-chip-listbox>
            }
          </form>
          <!-- Comparison table -->
          @if (data.comparison) {
            <div class="w-100" [@fadeAnimation]>
              <div class="comparison-table w-100">
                <div class="cmp-row cmp-header">
                  <div class="cmp-cell muted-color"></div>
                  <div class="cmp-cell main-color">Peech&nbsp;</div>
                  <div class="cmp-cell">{{ data.comparison.opponent }}&nbsp;</div>
                </div>
                @for (r of data.comparison.rows; track r) {
                  <div class="cmp-row">
                    <div class="cmp-cell feature">{{ r.feature }}</div>
                    <div class="cmp-cell icons">
                      @if (r.peech) {
                        <i class="ri-check-line main-color"></i>
                      }
                      @if (!r.peech) {
                        <i class="ri-close-line red-color"></i>
                      }
                    </div>
                    <div class="cmp-cell icons">
                      @if (r.opponent) {
                        <i class="ri-check-line main-color"></i>
                      }
                      @if (!r.opponent) {
                        <i class="ri-close-line red-color"></i>
                      }
                    </div>
                  </div>
                }
              </div>
              @if (data.comparison.footnote) {
                <div class="mt-20 fs-14 muted-color">
                  {{ data.comparison.footnote }}
                </div>
              }
            </div>
          }
          <!-- Pre-load animations with set dimensions to prevent layout shifts -->
          <canvas
            #animation
            class="animation"
            width="1024"
            [height]="1024 / (data.rive?.ratio || 1)"
            [ngClass]="{ 'd-none': !data.rive }"
            [ngStyle]="{
              'background-image': getBackgroundImageUrl(),
              'margin-top': data.rive?.marginTop,
            }"
            [@fadeAnimation]
          ></canvas>
          @if (data.videoFilePath) {
            <video
              class="video"
              [src]="data.videoFilePath + '#t=0.1'"
              type="video/mp4"
              autoplay
              muted
              playsinline
              [@fadeAnimation]
            ></video>
          }
          @if (data.mediaCite) {
            <div
              class="cite bg-light-green-color border-radius p-25 d-flex flex-column justify-content-center mt-16"
              [@fadeAnimation]
            >
              <div class="d-flex content flex-grow-1">
                <div class="d-flex">
                  <div class="quotas-image image mt-10"></div>
                </div>
                <div class="flex-grow-1 d-flex flex-column justify-content-space-between">
                  <div class="review">
                    {{ data.mediaCite }}
                  </div>
                </div>
              </div>
              <div class="mt-20 d-flex justify-content-center">
                <div class="media-logo image"></div>
              </div>
            </div>
          }
          @if (data.messages) {
            <div class="message-container" [@fadeAnimation]>
              <app-ai-chat [messages]="data.messages" (onComplete)="onChatComplete()"></app-ai-chat>
            </div>
          }
          @if (data.imageConfig) {
            <div
              class="image flex-grow-1 w-100"
              [ngStyle]="{
                'background-image': getBackgroundImageUrl(),
                'max-width': getImageMaxWidth(),
              }"
              [@fadeAnimation]
            ></div>
          }
          <!-- Text demo player -->
          @if (data.textDemo) {
            <app-text-player
              class="w-100"
              [fullText]="data.textDemo.fullText"
              [audioFile]="data.textDemo.audioAssetPath"
              [markups]="data.textDemo.markups"
              (audioProgressed)="onChatComplete()"
              [@fadeAnimation]
            ></app-text-player>
          }
          @if (
            (data.subtitle &&
              !data.isVoting &&
              (data.rive || data.videoFilePath || data.imageConfig)) ||
            (data.subtitle && data.textDemo)
          ) {
            <div class="subtitle bottom" [innerHTML]="data.subtitle" [@fadeAnimation]></div>
          }
          @if (data.planCards) {
            <div class="d-flex flex-column gap-12 w-100" [@fadeAnimation]>
              @for (card of data.planCards; track card.icon) {
                <div class="d-flex align-items-start gap-12 text-start bg-white border-radius p-15">
                  <i class="fs-20 main-color" [ngClass]="card.icon"></i>
                  <div class="fs-15">{{ card.text }}</div>
                </div>
              }
            </div>
          }
          @if (data.audioTracks) {
            @for (track of data.audioTracks; track track) {
              <app-audio-track
                class="w-100"
                #audioTrackRef
                [data]="track"
                (onPlayed)="onPlay($event, track)"
                [@fadeAnimation]
              ></app-audio-track>
            }
          }
          @if (data.hasSocialProof) {
            <app-social-proof [@fadeAnimation]></app-social-proof>
          }
          @if (data.userReview) {
            <app-user-review [data]="data.userReview" [@fadeAnimation]></app-user-review>
          }
        </div>
      }
      @if (data.isMentionedInShown) {
        <app-mentioned-in class="w-100 mt-20"></app-mentioned-in>
      }
    </div>
  }

  <div
    class="quiz-footer d-flex flex-column gap-8"
    [ngClass]="{
      'align-items-center voting-buttons':
        data && data.isVoting && (!data.textDemo || hasStartedTextDemo),
    }"
  >
    @if (
      data && (!data.options || data.isChips || data.isMultiple || data.isVoting || data.textDemo)
    ) {
      <div class="buttons-container d-flex justify-content-center slide-from-bottom">
        @if (data && (!data.options || data.isChips || data.isMultiple) && !data.isVoting) {
          <button
            mat-flat-button
            class="tagus continue-button"
            [disabled]="
              data.isRequired &&
              data.options &&
              (!form.value.selectedOptions || form.value.selectedOptions.length === 0)
            "
            (click)="buttonClicked()"
          >
            <ng-container i18n="@@continue">Continue</ng-container>
          </button>
        }

        <!-- Text demo play button -->
        @if (data && data.textDemo && !hasStartedTextDemo) {
          <button mat-flat-button class="tagus continue-button" (click)="playTextDemo()">
            <span class="ri-play-fill"></span>&nbsp;<ng-container i18n="@@play">Play</ng-container>
          </button>
        }

        @if (data && data.isVoting && (!data.textDemo || hasStartedTextDemo)) {
          <button mat-flat-button class="tagus" (click)="voteClicked('no')">👎</button>
          <button mat-flat-button class="tagus" (click)="voteClicked('miss')">🤷‍♂️</button>
          <button mat-flat-button class="tagus" (click)="voteClicked('yes')">👍</button>
        }
      </div>
    }

    <div class="info muted-color w-100 d-flex flex-column gap-4" [@fadeAnimation]>
      @if (footerMode === 'terms') {
        <div i18n="@@byContinuingAgree">By continuing you agree with</div>
      }

      @if (footerMode === 'terms') {
        <div class="w-100 d-flex align-items-center justify-content-center gap-4">
          <a
            class="muted-color"
            target="_blank"
            href="https://www.getpeech.com/terms"
            i18n="@@termsConditions"
            >Terms & Conditions</a
          >
          <div>•</div>
          <a
            class="muted-color"
            target="_blank"
            href="https://www.getpeech.com/privacy"
            i18n="@@privacyPolicy"
            >Privacy Policy</a
          >
          <div>•</div>
          <a
            class="muted-color"
            target="_blank"
            href="https://www.getpeech.com/subscription-terms"
            i18n="@@subscriptionPolicy"
            >Subscription Policy</a
          >
        </div>
      }

      @if (footerMode === 'address') {
        <div>Peech Labs, Inc., 169 Madison Ave, New York, NY 10016</div>
      }
    </div>
  </div>
</div>
